/* tslint:disable: jsx-no-lambda */
import * as React from 'react';
import { Grid, Typography, FormControl, Select, MenuItem } from '@material-ui/core';
import ReactSelect from 'react-select';
import makeAnimated from 'react-select/animated';

import { useInsurers } from 'hooks/useInsurers';
import { onerosoOptions, QUOTE_TYPE } from 'pages/BulkQuotation/resources';
import { useStyles } from './styles';

type TOption = { value: string; label: string };

interface CommonFieldsProps {
  insurers: TOption[];
  setInsurers: (v: TOption[]) => void;
  oneroso: string;
  setOneroso: (v: string) => void;
}

const animatedComponents = makeAnimated();

const selectStyles = {
  control: (base: any) => ({ ...base, minHeight: 40, borderColor: '#c4c4c4' }),
  menu: (base: any) => ({ ...base, zIndex: 5 }),
};

const CommonFields: React.FC<CommonFieldsProps> = ({
  insurers,
  setInsurers,
  oneroso,
  setOneroso,
}) => {
  const classes = useStyles();
  const { filteredInsurers } = useInsurers();

  return (
    <Grid container spacing={3}>
      <Grid item xs={6} sm={3} md={2}>
        <Typography className={classes.label}>Ramo</Typography>
        <div className={classes.pill}>{QUOTE_TYPE}</div>
      </Grid>

      <Grid item xs={12} sm={9} md={10}>
        <Typography className={classes.label}>Aseguradoras</Typography>
        <ReactSelect
          placeholder="Seleccionar..."
          closeMenuOnSelect={false}
          components={animatedComponents}
          styles={selectStyles}
          isMulti
          options={filteredInsurers}
          value={insurers}
          onChange={(v: any) => setInsurers((v as TOption[]) || [])}
        />
        <Typography className={classes.help}>Cada fila se cotiza con estas compañías.</Typography>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Typography className={classes.label}>Oneroso (prenda / leasing)</Typography>
        <FormControl fullWidth variant="outlined" size="small">
          <Select value={oneroso} onChange={(e) => setOneroso(e.target.value as string)}>
            {onerosoOptions.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default CommonFields;
